<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loadingSpinner">
      <b-spinner
        variant="success"
        label="Spinning"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <div v-if="!loadingSpinner">
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="6" cols="6" class="my-md-1">
              <b-row>
                <b-col class="font-weight-bold p-1 border-bottom border-right"
                  >Vehicle</b-col
                >
                <b-col class="p-1 border-bottom border-right">{{
                  getVehicle
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bold p-1 border-bottom border-right"
                  >Driver</b-col
                >
                <b-col class="p-1 border-bottom border-right">{{
                  getDriver
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bold p-1 border-bottom border-right"
                  >Pick Up Location</b-col
                >
                <b-col class="p-1 border-bottom border-right">{{
                  deliveryid.pickUpLocation
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bold p-1 border-bottom border-right"
                  >Drop Off Location</b-col
                >
                <b-col class="p-1 border-bottom border-right">{{
                  deliveryid.dropOffLocation
                }}</b-col>
              </b-row>

              <b-row>
                <b-col class="font-weight-bold p-1 border-bottom border-right"
                  >Delivery Date</b-col
                >
                <b-col class="p-1 border-bottom border-right">{{
                  formatDate(deliveryid.deliveryDate)
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bold p-1 border-bottom border-right"
                  >Delivery Status</b-col
                >
                <b-col class="p-1 border-bottom border-right">{{
                  deliveryid.deliveryStatus
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="font-weight-bold p-1 border-bottom border-right"
                  >Note</b-col
                >
                <b-col class="p-1 border-bottom border-right">{{
                  deliveryid.note
                }}</b-col>
              </b-row>
              <b-row>
                <b-col>
                  <CustomFieldsDetails
                    :AdditionalFields="deliveryid.additionalFields"
                    :ModuleReference="'Delivery'"
                    :ReadOnlyFields="true"
                  ></CustomFieldsDetails>
                </b-col>
              </b-row>
              <!-- <b-form @submit.prevent="submitDelivery">
              <b-form-group label="Vehicle" label-for="vehicle">
                <b-form-select
                  id="vehicleId"
                  v-model="deliveryid.vehicleID"
                 
                  disabled
                /> 
                
                
               </b-form-group>
              <b-form-group label="Driver ID" label-for="driverId"> 
                 <b-form-select
                  id="driverId"
                  v-model="deliveryid.driverID"
                  
                  disabled
                /> 
               </b-form-group>
              <b-form-group label="Pickup Location" label-for="pickUpLocation"> 
                 <b-form-input
                  id="pickUpLocation"
                  v-model="deliveryid.pickUpLocation"
                  required
                  readonly
                /> 
               </b-form-group>
              <b-form-group
                label="Dropoff Location"
                label-for="dropoffLocation"
              > 
                 <b-form-input
                  id="dropoffLocation"
                  v-model="deliveryid.dropoffLocation"
                  required
                  readonly
                /> 
               </b-form-group>
              <b-form-group label="Delivery Status" label-for="deliveryStatus"> 
                <b-form-select
                  id="deliveryStatus"
                  v-model="deliveryid.deliveryStatus"
                 
                  disabled
                /> 
              </b-form-group>
              <b-form-group label="Notes" label-for="notes">
                 <b-form-textarea id="notes" v-model="deliveryid.notes" readonly /> 
               </b-form-group>
            </b-form>  -->
            </b-col>

            <b-col md="6" cols="6" class="my-md-1">
              <div align="center">
                <b-button
                  variant="primary"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  target="_blank"
                  :href="`https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
                    deliveryid.pickUpLocation
                  )}&destination=${encodeURIComponent(
                    deliveryid.dropOffLocation
                  )}`"
                  >View Delivery Route</b-button
                >
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>

    <!-- Delivery Items modal section -->
    <b-modal v-model="modalOpen" title="Select Delivery Items" centered>
      <b-table
        striped
        hover
        responsive
        :items="deliveryItems"
        :fields="deliveryItemFieldsModal"
      >
        <template #cell(invoiceNo)="data">
          {{ data.item.invoice.invoiceNo }}
        </template>

        <template #cell(itemId)="data">
          <span> {{ getProductName(data.item.itemId) }}</span>
        </template>

        <!-- <template #cell(description)="data">
      {{ data.item.description }}
    </template>

    <template #cell(quantity)="data">
      {{ data.item.quantity }}
    </template> -->

        <template #cell(check)="row">
          <b-form-checkbox v-model="row.item.selected" />
        </template>
      </b-table>
      <template #modal-footer>
        <b-button @click="saveChanges" variant="primary">Save Changes</b-button>
      </template>
    </b-modal>

    <!-- Delivery Items Section -->

    <b-card v-if="!loadingSpinner" class="mt-3">
      <b-card-header>
        <div class="d-flex justify-content-between align-items-center m-1">
          <div>Selected Delivery Item Details</div>
          <!-- <b-button @click="toggleModal" variant="primary">Select</b-button> -->
        </div>
      </b-card-header>

      <b-col cols="12" md="4" xl="3">
      <b-card-body>
        <!-- <div class="d-flex justify-content-between align-items-center m-1"> -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            @click="handleDeliveryDocBtn(id)"
            block
          >
            Documents
          </b-button>

          <b-modal
            ref="modal-view-delivery-document"
            id="modal-view-delivery-document"
            ok-only
            ok-title="View"
            centered
            size="lg"
            title="View Documents"
            :hide-footer="true"
          >
            <DocumentUpload
              @deleteFile="deleteFile"
              @downloadFile="downloadFile"
              @uploadFiles="uploadFiles"
              :documentDetails="documentDetails"
            />
          </b-modal>
          <!-- </div> -->
      </b-card-body>
    </b-col>

      <b-card-body>
        <!-- Table for delivery items, showing selected items -->

        <b-table
          v-if="!loadingSpinner2"
          striped
          hover
          responsive
          :items="selectedItemsWithStatus"
          :fields="selectedItemFields"
        >
          <template #cell(productID)="data">
            {{ getProductName(data.item.productID) }}
          </template>

          <template #cell(invoiceNo)="data">
            <a
              :href="'/invoice/view/' + data.item.deliveryNote.invoice.id"
              target="_blank"
            >
              {{ data.item.deliveryNote.invoice.invoiceNo }}
            </a>
          </template>
          <template #cell(customer)="data">
            {{
              data.item.deliveryNote.invoice.leadClient &&
              data.item.deliveryNote.invoice.leadClient.type == 1
                ? data.item.deliveryNote.invoice.leadClient.companyName
                : (
                    (data.item.deliveryNote.invoice.leadClient.surname || "") +
                    " " +
                    (data.item.deliveryNote.invoice.leadClient.otherName || "")
                  ).trim()
            }}
          </template>
          <template #cell(address)="data">
            {{
              (data.item.deliveryNote.invoice.leadClient.addressLine1 || "") +
              " " +
              (data.item.deliveryNote.invoice.leadClient.addressLine2 || "")
            }}
          </template>

          <template #cell(quantity)="data">
            {{
              (data.item.deliveryNote.quantity || "")
            }}
          </template>
          
          <template #cell(status)="row">
            <div
    class="d-flex align-items-center"
    v-if="row.item.status !== 'DELIVERED' && row.item.editingStatus"
    @click="editField(row.item, 'editingStatus')"
  >
              <b-badge :variant="getStatusColor(row.item.status)">{{
                getStatusText(row.item.status)
              }}</b-badge>

              <feather-icon icon="EditIcon" class="ml-2" />
            </div>

            <div v-else>
              <!-- {{ row.item.deliveryNote }} -->
              <b-form-select
                v-model="row.item.status"
                :options="deliveryStatusV2Options"
                @change="saveField(row.item, 'editingStatus')"
                :disabled="row.item.status === 'DELIVERED' && row.item.hasSignature == true"
              />
            </div>
          </template>

          <template #cell(comment)="data">
                <div class="d-flex align-items-center"
                  v-if="!data.item.editingComment"
                  @click="editCommentField(data.item, 'editingComment')"
                >
                  <span>{{ data.item.deliveryNote.comment }}</span>
                   <feather-icon icon="EditIcon" class="ml-2" />
                </div>
                <div v-else>
                  <b-form-input
                    v-model="data.item.comment"
                    @change="saveCommentField(data.item, 'editingComment')"
                  />
                </div>
              </template>

          <template #cell(actions)="data">
            <!-- Conditional rendering of buttons based on computed property -->
            <div v-if="data.item.status == 'DELIVERED'">
              <b-button
                v-if="data.item.hasSignature == false"
                variant="primary"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                @click="showSignaturePad(data.item.deliveryNoteID)"
              >
                Sign
              </b-button>
              <b-button
                v-if="data.item.hasSignature == true"
                variant="primary"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                @click="viewSignature(data.item.deliveryNoteID)"
              >
                View Signature
              </b-button>
            </div>
          </template>
        </b-table>
        <div class="d-flex justify-content-center mb-1" v-if="loadingSpinner2">
          <b-spinner
            variant="success"
            label="Spinning"
            style="width: 3rem; height: 3rem"
          ></b-spinner>
        </div>
      </b-card-body>
    </b-card>

    <b-card>
      <div>
    <b-row>
      <b-col md="2" sm="4" class="my-1">
        <b-form-group class="mb-0">
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
        </b-form-group>
      </b-col>
      <b-col md="2" sm="8" class="my-1">

      </b-col>
      <!-- <b-col md="8" class="my-1">
        <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
          class="mb-0">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col> -->
    
    <b-table :items="userlogs" :fields="fields" striped responsive :per-page="perPage" :current-page="currentPage"
      :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
      :filter-included-fields="filterOn" @filtered="onFiltered">

      <template v-slot:cell(dateTime)="data">
                {{ convertTimestampToDate(data.item.dateTime) }}
              </template>

      <template #cell(show_details)="row">
        <b-form-checkbox v-model="row.detailsShowing" plain class="vs-checkbox-con" @change="row.toggleDetails">
          <span class="vs-checkbox">
            <span class="vs-checkbox--check">
              <i class="vs-icon feather icon-check" />
            </span>
          </span>
          <span class="vs-label">{{ row.detailsShowing ? 'Hide' : 'Show' }}</span>
        </b-form-checkbox>
      </template>

      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col md="12" class="mb-1" v-if="row.item.oldValues == null">
              <strong>Original Values: </strong>Nothing found
            </b-col>
            <b-col md="12" class="mb-1" v-if="row.item.oldValues !== null">
              <strong>Original Values: </strong>
              <b-table :items="beautifyJson(row.item.oldValues)" :fields="['key', 'value']" bordered></b-table>
            </b-col>
            <b-col md="12" class="mb-1">
              <strong>Changed Values: </strong>
              <b-table :items="beautifyJson(row.item.newValues)" :fields="['key', 'value']" bordered></b-table>
           
            </b-col>

          </b-row>
         
        </b-card>
      </template> 
      
    </b-table>
    
    <b-col cols="12">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
        <b-form-group>
          Showing 
          {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
          to 
          {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
          of 
          {{ totalRows > 0 ? totalRows : 0 }} 
          entries
        </b-form-group>
      </b-col>

      </b-row>

  </div>
    </b-card>

    <!-- Modal for Digital Signature Pad -->
    <b-modal
      ref="signatureModalOpen"
      title="Digital Signature"
      hide-footer
      centered
    >
      <VueSignaturePad
        id="signature"
        width="100%"
        height="30vh"
        ref="signaturePad"
        style="border: 1px solid #ccc; background-color: #fff"
        :options="{
          onBegin: () => {
            $refs.signaturePad.resizeCanvas();
          },
        }"
      />
      <div class="text-center mt-3">
        <b-button class="mr-1" @click="saveSignature" variant="success"
          >Save</b-button
        >
        <b-button class="mr-1" @click="undo" variant="warning">Undo</b-button>
        <b-button @click="clearSignature" variant="danger">Clear</b-button>
      </div>
    </b-modal>

    <!-- View Signature Modal -->
    <b-modal
      title="View Signature"
      hide-footer
      centered
      ref="viewSignatureModalOpen"
      size="md"
    >
      <!-- Display the saved signature -->
      <img
        :src="signatureData"
        alt="Digital Signature"
        style="
          width: 100%;
          height: 30vh;
          border: 1px solid #ccc;
          background-color: #fff;
        "
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination, BInputGroupAppend,
  BFormTextarea,
  BCardHeader,
  BCardBody,
  BButton,
  BTable,
  BModal,
  BFormCheckbox,
  BBadge,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { readonly } from "@vue/composition-api";
import { customSwal, customError, customErrorMessage } from "@/libs/customFn";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import api from "@/api/api-v1-config";
import {
  deleteInvoiceDocument,
  uploadMultipleInvoiceDocuments,
  uploadInvoiceDocument,
  downloadInvoiceDocument,
} from "@/store/invoices/services";
export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BPagination, BInputGroupAppend,
    BFormTextarea,
    BButton,
    BTable,
    BModal,
    BFormCheckbox,
    BBadge,
    BSpinner,
    CustomFieldsDetails,
    DocumentUpload,
  },
  // props: {
  //   informationData: {
  //     type: Array,
  //     default: () => { },
  //   },
  // },
  data() {
    return {
      id: this.$route.params.id,
      token: localStorage.getItem("accessToken"),
      role: JSON.parse(localStorage.getItem("userData")).role,
      userlogs: [],
      showSpinner: true,
      modalOpen: false,
      vehicleID: "",
      driverID: "",
      pickUpLocation: "",
      dropOffLocation: "",
      deliveryStatus: "",
      note: "",
      signatureData: null,
      deliveryNoteID: null,
      loadingSpinner: true,
      loadingSpinner2: true,
      deliveryItemFieldsModal: [
        { key: "invoiceNo", label: "Inv #" },
        { key: "itemId", label: "Product Name" },
        { key: "note", label: "Description" },
        { key: "status", label: "Status" },
        { key: "check", label: "Select" },
      ],
      selectedItemFields: [
        { key: "productID", label: "Product Name" },
        //{ key: 'note', label: 'Description' },
        { key: "invoiceNo", label: "Invoice Number" },
        { key: "customer", label: "Customer" },
        { key: "address", label: "Address" },
        { key: "quantity", label: "Quantity" },
        { key: "status", label: "Status", sortable: true },
        { key: "comment", label: "Delivery Note", sortable: true },
        "actions",
      ],
      //products: [],PENDING, INTRANSIT, DELIVERED, CANCELLED
     // deliveryStatusOptions: ["PENDING", "INTRANSIT", "DELIVERED", "CANCELLED", "RETURNED"],
      deliveryStatusOptions: [
        { value: "0", text: "PENDING" },
        { value: "1", text: "INTRANSIT" },
        { value: "2", text: "DELIVERED" },
        { value: "3", text: "CANCELLED" },
        { value: "4", text: "RETURNED" },
        { value: "5", text: "SCHEDULED" },
      ],
      deliveryStatusV2Options: [
      { value: "PENDING", text: "PENDING" },
        { value: "INTRANSIT", text: "INTRANSIT" },
        { value: "DELIVERED", text: "DELIVERED" },
        { value: "CANCELLED", text: "CANCELLED" },
        { value: "RETURNED", text: "RETURNED" },
        { value: "SCHEDULED", text: "SCHEDULED" },
      ],
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      fields: [
        'show_details',
        "userName",
        // { key: "tableName", sortable: true },
        { key: "dateTime", sortable: true }
      ],
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapGetters("deliveriesModule", {
      deliveryid: "deliveryid",
      selectedItemsWithStatus: "item",
      signature: "signature",
      signatureid: "signatureid",
      loading: "loading",
    }),

    ...mapGetters("vehicleModule", {
      vehicleId: "vehicleId",
      loading: "loading",
    }),

    ...mapGetters("userModule", {
      usersId: "usersId",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      products: "product",
      loading: "loading",
    }),
    ...mapGetters("deliveryModule", {
      deliveryItems: "deliverynotes",
      loadingNote: "loading",
    }),

    ...mapGetters("invoiceModule", {
      invoiceId: "invoiceId",
      documents: "documents",
      file: "file",
      loadingInvoice: "loading",
    }),
    ...mapGetters("tenantModule", {
      logs: "logs",
      loading: "loading",
    }),
    // selectedItemsWithStatus() {
    //   return this.deliveryItems.filter((item) => item.selected);
    // },

    formattedDeliveryItems() {
      if (!this.deliveryItems || !Array.isArray(this.deliveryItems)) {
        return [];
      }
      return this.deliveryItems.flatMap((invoice) => {
        if (!invoice.invoiceItem && invoice.status !== "PENDING") {
          return [];
        }
        return invoice.invoiceItem.map((item) => ({
          ...item,
          invoiceNo: invoice.invoiceNo,
          //selected: false
        }));
      });
    },
    //PENDING, INTRANSIT, DELIVERED, CANCELLED
    getVehicle() {
      const make = this.vehicleId.make;
      return make;
    },

    getDriver() {
      const driver = this.usersId.firstName + " " + this.usersId.lastName;
      return driver;
    },

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },

    getStatusText() {
    return (status) => {
      const statusOption = this.deliveryStatusV2Options.find(option => option.value == status);
      return statusOption ? statusOption.text : '';
    };
  }
  },
  methods: {
    ...mapActions("deliveriesModule", [
      "addDeliveryAction",
      "getDeliveryByIDAction",
      "updateDeliveryItemAction",
      "getDeliveryListAction",
      "getDeliveryItemListAction",
      "addDeliveryItemAction",
      "updateDeliveryItemStatusAction"
    ]),
    ...mapActions("vehicleModule", ["getVehicleByIDAction"]),
    ...mapActions("userModule", ["getUserIdAction"]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("invoiceModule", [
      "getInvoicesListAction",
      "getInvoiceIdAction",
      "getInvoiceDocumentListAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("deliveryModule", [
      "getAllDeliveryNoteListAction",
      "updateDeliveryNotesAction",
      "getDeliverySignatureByIDAction",
      "addDeliverySignatureAction",
    ]),
    ...mapActions("tenantModule",["getUserLogsAction"]), 

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    getDeliveryStatusText(value) {
  const statusMap = ["PENDING", "INTRANSIT", "DELIVERED", "CANCELLED", "RETURNED"];
  if (typeof value === 'number' && value >= 0 && value < statusMap.length) {
    return statusMap[value];
  }
  return value;
},

formatDate(date) {
      if (date != null) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(date).toLocaleDateString("en-US", options);
      } else {
        return "-";
      }
    },

    convertTimestampToDate(date) {
  if(date != null){
    const options = { 
      year: "numeric", 
      month: "short", 
      day: "numeric", 
      hour: "2-digit", 
      minute: "2-digit", 
      second: "2-digit", 
      hour12: true  // Optional: To get 12-hour format (AM/PM)
    };
    return new Date(date).toLocaleDateString("en-US", options);
  }
  else {
    return "-";
  }
} ,

beautifyJson(jsonData) {
  if (typeof jsonData === 'string') {
    try {
      jsonData = JSON.parse(jsonData);
    } catch (e) {
      console.error('Unable to parse JSON data', e);
      return [];
    }
  }

  const statusEnumMap = {
    0: "PENDING",
    1: "INTRANSIT",
    2: "DELIVERED",
    3: "CANCELLED",
    4: "RETURNED",
    5: "SCHEDULED"
  };

  if (jsonData && typeof jsonData === 'object') {
    return Object.keys(jsonData).map(key => {
      let value = jsonData[key];

      // Translate deliveryStatus if it’s a numeric enum
      if (key === 'deliveryStatus' && typeof value === 'number') {
        value = statusEnumMap[value] || value;
      }

      return { key: key, value: value };
    });
  }

  return [];
},

   async getLogs() {
      // let conf = {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: "Bearer " + this.token,
      //   },
      // };
      let payload = {
        TableName : "Delivery",
        PrimaryKey : this.id
      };
      
       await this.getUserLogsAction(payload).then(() => {
        this.userlogs = this.logs;
        console.log("test", this.logs);
        this.totalRows = this.userlogs.length;
       });
      //  .then(() => {
      //   this.logs = this.logs;
      // });

//       this.logs = userlogs;
// console.log("test6520", this.userlogs);
// console.log("test", this.logs);
//       this.totalRows = this.logs.length;
      
      
      // .then(() => {
      //   console.log("result", this.userlogs);
      //    this.logs = this.userlogs;
      //   this.showSpinner = false;
      // })
      // .catch((error) => {
      //     console.log(error);
      //     this.showSpinner = false;
      //   });

      // this.totalRows = this.userlogs.length;
      // await api
      //   .get("/personal/logs", conf)

      //   .then((response) => {
      //     this.userlogs = response.data.filter(item => item.tableName === 'Delivery');

      //     this.showSpinner = false;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     this.showSpinner = false;
      //   });
    },

    async handleDeliveryDocBtn(referenceId) {
      console.log("referenceId", referenceId);
      try {
        await this.getInvoiceDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          let loader = this.$swal({
            title: "Processing...",
            text: "Please wait while the document(s) is being featched",
            onOpen: () => {
              this.$swal.showLoading();
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
            buttonsStyling: false,
            showConfirmButton: false,
          });
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
          this.$swal.close();
        }
        this.$refs["modal-view-delivery-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadInvoiceDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.id;
      if (selectedFiles.length > 1) {
        await uploadMultipleInvoiceDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadInvoiceDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }
      await this.getInvoiceDocumentListAction(referenceId);
      this.documentDetails.isDelete = true;
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-delivery-document");
      });
    },

    async deleteFile(id) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteInvoiceDocument(id)
        .then((response) => {
          loader.close();
          customSwal("Document deleted successfully!");
          
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getInvoiceDocumentListAction(this.id);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-delivery-document");
      });
    },

    editCommentField(item, field) {
      this.$set(item, field, true);
    },

    saveCommentField(item, field) {
      this.$set(item, field, false);

      // { value: "PENDING", text: "PENDING" },
      //   { value: "INTRANSIT", text: "INTRANSIT" },
      //   { value: "DELIVERED", text: "DELIVERED" },
      //   { value: "CANCELLED", text: "CANCELLED" },
      //   { value: "RETURNED", text: "RETURNED" },
      //   { value: "SCHEDULED", text: "SCHEDULED" },
      let stats = 0;

      if(item.status == "PENDING") { stats = 0 }
      else if(item.status == "INTRANSIT") { stats = 1 }
      else if(item.status == "DELIVERED") { stats = 2 }
      else if(item.status == "CANCELLED") { stats = 3 }
      else if(item.status == "RETURNED") { stats = 4 }
      else if(item.status == "SCHEDULED") { stats = 5 }

      let payload = {
        id: item.deliveryNoteID,
        itemId: item.id,
        deliveryDate: item.deliveryNote.deliveryDate,
        note: item.deliveryNote.note,
         status: stats,
        comment: item.comment,
      };

     // this.updateDeliveryItemAction(payload)
     this.updateDeliveryNotesAction(payload)
        .then(() => {
          this.successAdd();
          this.$router.push({ 
              name: "view-delivery", 
              params: { id: this.id } 
            });
            window.location.reload();
            //this.$router.replace({ path: this.$route.path, query: { ...this.$route.query } });
            //this.$forceUpdate();
        })
        .catch((error) => {
          // Error handling
          this.errorAdd();
          console.error(error);
        });
    },

    successAdd() {
      this.$swal({
        title: "Delivery Item!",
        text: "You have successfully updated the delivery item details!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },


    showSignaturePad(deliverynoteID) {
      this.deliveryNoteID = deliverynoteID;
      console.log("Show Signature Pad", this.deliveryNoteID);
      this.$refs.signatureModalOpen.show();
    },

    async viewSignature(deliverynoteID) {
      this.deliveryNoteID = deliverynoteID;
      try {
        if (
          this.signatureData == null ||
          this.signatureData == "" ||
          this.signatureData == undefined
        ) {
          // If not populated, fetch the signature data
          const response = await this.getDeliverySignatureByIDAction(
            deliverynoteID
          );
          this.signatureData = response.digitalSignature;
        }

        console.log("signatureData", this.signatureData);
        this.$refs.viewSignatureModalOpen.show();
      } catch (error) {
        console.error("Error fetching digital signature:", error);
      }

      // this.getDeliverySignatureByIDAction(this.deliveryNoteID)
      //   .then((response) => {

      //     console.log("start",response);
      //     if (response && response) {
      //       this.signatureData = response.digitalSignature;
      //       console.log(this.signatureData);
      //       this.$refs.signatureOpen.show();
      //     }

      //   })
      //   .catch(error => {
      //     console.error(error);
      //   });
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (!isEmpty) {
        console.log("noteID", this.deliveryNoteID);
        let payload = {
          parentID: this.deliveryNoteID,
          digitalSignature: data,
          type: 0,
        };
        console.log("payload", payload);
        this.addDeliverySignatureAction(payload)
          .then(() => {
            this.$refs.signatureModalOpen.hide();
            this.getDeliveryItemListAction(this.id);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    submitDelivery() {
      // Handle form submission logic here
    },
    // toggleModal() {
    //   this.modalOpen = !this.modalOpen;
    // },

    getProductName(id) {
      const prod = this.products.find((s) => s.id === id);
      return prod ? prod.name : "-";
    },

    saveChanges() {
      // Save changes and close the modal
      const selected = this.deliveryItems.filter((item) => item.selected);
      //this.selectedItems = selected;
      this.$store.dispatch("addDeliveryItemAction", selected);
      this.modalOpen = false;
    },
    editField(item, field) {
      this.$set(item, field, true);
    },

    saveField(item, field) {
      this.$set(item, field, false);

      let payload = {
        id: item.id,
        status: item.status,
      };
    //console.log("statustest", payload);
      this.updateDeliveryItemStatusAction(payload)
      .then(() => {
          this.successAdd();

          let stats = 0;

if(item.status == "PENDING") { stats = 0 }
else if(item.status == "INTRANSIT") { stats = 1 }
else if(item.status == "DELIVERED") { stats = 2 }
else if(item.status == "CANCELLED") { stats = 3 }
else if(item.status == "RETURNED") { stats = 4 }
else if(item.status == "SCHEDULED") { stats = 5 }

          let payload2 = {
        id: item.deliveryNoteID,
        itemId: item.id,
        deliveryDate: item.deliveryNote.deliveryDate,
        note: item.deliveryNote.note,
         status: stats,
        comment: item.deliveryNote.comment,
      };
      console.log("payload2", payload2);
      this.updateDeliveryNotesAction(payload2).then(() => {
        //console.log("ine finiiiiiiii");
        // this.$router.push({ 
        //       name: "view-delivery", 
        //       params: { id: this.id } 
        //     });
        window.location.reload();
      });
      
         
        })
        .catch((error) => {
          // Error handling
          this.error(ex.response.data);
          //console.error(error);
        });
        // .then(() => {
        //   this.successAdd();
        //   this.$router.push({ 
        //       name: "view-delivery", 
        //       params: { id: this.id } 
        //     });
        // })
        // .catch((error) => {
        //   // Error handling
        //   //this.errorAdd();
        //   console.error(error);
        // });
    },

    getStatusColor(status) {
      switch (status) {
        case "PENDING":
          return "warning";
        case "INTRANSIT":
          return "info";
        case "DELIVERED":
          return "success";
        case "CANCELLED":
          return "info";
        default:
          return "secondary";
      }
    },
  },

  // mounted() {
  //   // Set the initial number of items
  //   this.totalRows = this.informationData.length
  // },
  async mounted() {
    setTimeout(() => {
      this.loadingSpinner = false;
    }, 5000);
    setTimeout(() => {
      this.loadingSpinner2 = false;
    }, 12000);
    await this.getDeliveryByIDAction(this.id);
    await this.getVehicleByIDAction(this.deliveryid.vehicleID);
    await this.getUserIdAction(this.deliveryid.driverID);

    //await this.getInvoiceIdAction(this.invoiceId);
    await this.getAllDeliveryNoteListAction();
    await this.getProductListAction();
    // /await this.getDeliverySignatureByIDAction(this.deliveryNoteID);
    await this.getDeliveryItemListAction(this.id);
    //console.log("testtttt", this.selectedItemsWithStatus);

    await this.getLogs();
   // this.totalRows = this.informationData.length

    // try {
    //   const response = await this.getInvoicesListAction();
    //   if (response.success) {
    //     this.totalRows = this.deliveryItems.length;
    //   } else {
    //     console.error("Failed to fetch delivery notes", response.message);
    //   }
    // } catch (error) {
    //   console.error(error);
    // }

    // try {
    //   const invoiceIdResponse = await this.getInvoiceIdAction(this.invoiceId);
    //   if (invoiceIdResponse.success) {
    //     this.deliveryItems = invoiceIdResponse.result;
    //     this.deliveryItems.forEach(invoice => {
    //       invoice.invoiceItem.forEach(element => {
    //         this.products.push({
    //           value: element.itemId,
    //           text: element.itemName,
    //         });
    //       });
    //     });
    //   } else {
    //     console.error("Failed to fetch invoice details", invoiceIdResponse.message);
    //   }
    // } catch (error) {
    //   console.error(error);
    // }
  },
};
</script>

<style scoped>
/* Add your existing styles here */
</style>
